export default __webpack_public_path__ + "static/media/setting-active.2e9ce2fe.svg";